// extracted by mini-css-extract-plugin
export var modal = "_dl-0";